module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/findx2.8396d6ea.png";